import { GoogleAd } from '../../../sharedComponents'
import styled from 'styled-components'
import AdPlacementCss from '../AdPlacementCss'
import { GoogleAdSlot } from '../../../sharedComponents/types'
import { isDesktop } from '../../../client'
import { useEffect, useState } from 'react'

const StyledPoster = styled(GoogleAd)`
  ${AdPlacementCss({ width: 300, height: 600 })}
`
const PosterSlot: GoogleAdSlot = {
  id: 'Poster',
  path: '/36476105/Reshet_desktop/Poster',
  size: [300, 600],
}
const Poster = () => {
  const [slot, setSlot] = useState<GoogleAdSlot | null>(null)

  useEffect(() => {
    if (isDesktop()) {
      setSlot(PosterSlot)
    }
    return () => setSlot(null)
  }, [])

  return slot && <StyledPoster slot={slot} />
}
export default Poster
